import EventScope from 'owa-service/lib/contract/EventScope';
import { cancelCalendarEvent } from 'owa-calendar-events-actions';
import { ControlIcons } from 'owa-control-icons';
import { NotesEditorViewState, lazyOpenNotesEditor } from 'owa-calendar-notes-editor';
import { openItemPeekInternal } from './openItemPeekInternal';
import { openItemPeekToCancel } from '../actions/itemPeekActions';
import { orchestrator } from 'satcheljs';
import getStore from '../store/store';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';

/**
 * Opens the item peek with the cancellation dialog already expanded
 * @param item the item to open the peek for
 * @param eventScope whether acting on whole series, occurrence or from this date forward
 * @param actionSource the tag identifying the source of the action
 * @param titleText optional text to show on cancellation form above message input
 */
orchestrator(openItemPeekToCancel, actionMessage => {
    let { item, eventScope, actionSource, titleText } = actionMessage;

    const notesEditorViewState: NotesEditorViewState = {
        ...createEditorViewState(''),
        eventScope: eventScope,
        titleText: titleText,
        iconName: ControlIcons.RemoveEvent,
        onSend: (eventScope: EventScope, notes?: string) => {
            // Action Sources = Surface - SurfaceContextMenu - SurfacePeek
            cancelCalendarEvent(
                item.ItemId,
                actionSource,
                eventScope,
                CalendarComponent.CalendarSurface,
                notes
            );
        },
        proposedTime: null,
        showNotifyToggle: false,
        sendResponse: true,
        forwardees: null,
        isCancelledEvent: true,
        isDeclinedSeriesInstance: false,
        isTxpShareEvent: false,
    };

    if (isCurrentlyOpenedPeek(item.ItemId.Id)) {
        // If the peek is already open for this item, just show the notes editor
        // and avoid trigger the peek to reopen for the same item
        lazyOpenNotesEditor.importAndExecute(
            item.ItemId,
            notesEditorViewState.eventScope,
            notesEditorViewState.onSend,
            notesEditorViewState.titleText,
            notesEditorViewState.iconName,
            notesEditorViewState.proposedTime,
            notesEditorViewState.forwardees,
            notesEditorViewState.showNotifyToggle,
            notesEditorViewState.sendResponse,
            notesEditorViewState.isCancelledEvent,
            notesEditorViewState.isDeclinedSeriesInstance,
            notesEditorViewState.isTxpShareEvent
        );
    } else {
        openItemPeekInternal(item, notesEditorViewState);
    }
});

function isCurrentlyOpenedPeek(itemId: string): boolean {
    const viewState = getStore().viewState;
    if (viewState?.itemId) {
        return itemId === viewState.itemId;
    }
    return false;
}
